export default function PHP_error_get_last() {
  return (
    <div>
      <h1>PHP_error_get_last</h1>
    </div>
  );
}
